/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { personIndex } from '../../axios/personIndex'
import type {
	PersonIndexError,
	PersonIndexPathParams,
	PersonIndexQueryParams,
	PersonIndexResponse,
} from '../../types/PersonIndex'

export const personIndexQueryKey = (
	organisationId: PersonIndexPathParams['organisationId'],
	params?: PersonIndexQueryParams,
) => [
	{ url: '/organisations/:organisationId/persons', params: { organisationId } },
	...(params ? [params] : []),
] as const

export type PersonIndexQueryKey = ReturnType<typeof personIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::index */
export function personIndexQueryOptions(
	organisationId: PersonIndexPathParams['organisationId'],
	params?: PersonIndexQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<PersonIndexResponse, AxiosError<PersonIndexError>, PersonIndexResponse, PersonIndexQueryKey>({
		queryKey: personIndexQueryKey(organisationId, params),
		queryFn: ({ signal }) => personIndex(organisationId, params, { signal, ...config }).then(res => res.data),
		enabled: !!organisationId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::index */
export function usePersonIndex<TSelectData = PersonIndexResponse>(
	organisationId: PersonIndexPathParams['organisationId'],
	params?: PersonIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<PersonIndexResponse, AxiosError<PersonIndexError>, TSelectData, PersonIndexQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PersonIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...personIndexQueryOptions(organisationId, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::index */
export function usePersonIndexSuspense<TSelectData = PersonIndexResponse>(
	organisationId: PersonIndexPathParams['organisationId'],
	params?: PersonIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					PersonIndexResponse,
					AxiosError<PersonIndexError>,
					TSelectData,
					PersonIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PersonIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...personIndexQueryOptions(organisationId, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
